const watchAll = require('./watch-all');

/**
 * Get all current values for a list of paths, filtered for pending values and returned in order
 * @param {Observable} stream - the output of a muster `get` query
 * @returns {Promise<Array<PathValue>>} - a promise resolving to an array of PathValue objects
 * in the order they were requested
 */
function getAll(stream) {
  return watchAll(stream).take(1).toPromise();
}

module.exports = getAll;
